import React, { ReactElement } from 'react';
import classNames from 'classnames';

import './filter.scss';

const COMPANY_VIEW_CARD_RATING_FILTER_TABS = [
    'Wszystkie opinie',
    'Tylko Wiarygodne'
];

interface CompanyViewCardRatingFilterProps {
    activateTab(tab: number): void;
    activeTab: number;
}

const CompanyViewCardRatingFilter: React.FC<CompanyViewCardRatingFilterProps> = ({ activateTab, activeTab }): ReactElement => {
    function getKey(tab: number): string {
        return `company-view-card-rating-filter-key-${tab}`;
    }

    return (
        <div className="company-view-card__rating-type">
            {COMPANY_VIEW_CARD_RATING_FILTER_TABS.map((value, index) => (
                <a className={classNames({ 'tabs__item-link': true, 'active': activeTab === index })} onClick={(): void => {
                    activateTab(index);
                }} key={getKey(index)}
                >
                    {value}
                </a>
            ))}
        </div>
    );
};

export default CompanyViewCardRatingFilter;
